var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { trigger: "click" },
      on: { "visible-change": _vm.actionOnDropdownChange }
    },
    [
      _c(
        "div",
        { staticClass: "el-dropdown-link" },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                id: "tooltip",
                effect: "dark",
                content: "Notificações",
                placement: "bottom"
              }
            },
            [
              _c(
                "div",
                { staticClass: "notificacao" },
                [
                  _c(
                    "el-badge",
                    { attrs: { value: _vm.novasNotificacoes, max: 10 } },
                    [
                      _c(
                        "div",
                        { staticClass: "fa-stack fa-lg" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "bell", size: "2x" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "drop-down-menu",
          attrs: { slot: "dropdown" },
          slot: "dropdown"
        },
        [
          _vm._l(_vm.notificacoes, function(notificacao) {
            return _c(
              "el-dropdown-item",
              { key: notificacao.id, staticClass: "drop-down-item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "notificacao-body",
                    class: [
                      notificacao.recebedor.notificacaoLida
                        ? "visualizadas"
                        : "novas"
                    ]
                  },
                  [
                    _c("div", { staticClass: "header" }, [
                      _c("div", { staticClass: "titulo" }, [
                        _vm._v(_vm._s(notificacao.titulo))
                      ]),
                      _c("div", { staticClass: "data" }, [
                        _vm._v(_vm._s(notificacao.dataCriacao))
                      ])
                    ]),
                    _c("p", { staticClass: "body" }, [
                      _vm._v(_vm._s(notificacao.mensagem))
                    ])
                  ]
                )
              ]
            )
          }),
          _c("div", { staticClass: "notificacao-footer" }, [
            _vm.temMaisNotificacoes
              ? _c("div", { staticClass: "load-button" }, [
                  !_vm.isLoading
                    ? _c("a", { on: { click: _vm.loadMoreNotificacoes } }, [
                        _vm._v("Carregar mais")
                      ])
                    : _c("i", { staticClass: "el-icon-loading" })
                ])
              : _c("div", { staticClass: "end-notificacao" }, [
                  !_vm.temMaisNotificacoes &&
                  _vm.notificacoes.length > 0 &&
                  _vm.pagina !== 0
                    ? _c("span", [_vm._v("Não há mais notificações")])
                    : _vm._e(),
                  _vm.notificacoes.length == 0
                    ? _c("span", [_vm._v("Não há notificações")])
                    : _vm._e()
                ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11c7d41a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c7d41a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notificacao.vue
// module id = null
// module chunks = 